<script setup lang="ts">
import type { IconConstant } from '@tpg/grammar-web-icons';
import type { Slot } from 'vue';

export interface GrammarModalProps {
  showCloseButton?: boolean;
  preventCloseOnClickOutside?: boolean;
  iconTemplate?: IconConstant | '';
  label?: string;
  secondaryLabel?: string;
  isOpen?: boolean;
  positioning?: 'global' | 'local';
  allowScroll?: boolean;
  type?: 'default' | 'error' | 'danger';
}

interface GrammarModalSlots {
  content?: Slot;
  footer?: Slot;
}

const props = withDefaults(defineProps<GrammarModalProps>(), {
  showCloseButton: false,
  preventCloseOnClickOutside: false,
  iconTemplate: '',
  label: '',
  secondaryLabel: '',
  isOpen: false,
  positioning: 'global',
  allowScroll: false,
  type: 'default',
});

const emit = defineEmits(['close', 'show']);
const slots = defineSlots<GrammarModalSlots>();

function onClose() {
  emit('close');
}
function onShow() {
  emit('show');
}
</script>

<template>
  <tpg-modal-dialog
    v-bind="props"
    @tpg-show="onShow"
    @tpg-close="onClose"
  >
    <div v-if="slots.content" slot="content">
      <slot name="content" />
    </div>

    <div v-if="slots.footer" slot="footer">
      <slot name="footer" />
    </div>
  </tpg-modal-dialog>
</template>
